import { useState, useEffect } from 'react';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { IssueTypeId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ServiceQueryResult } from '@atlassian/jira-software-deployments-service-query-types/src/services/types.tsx';
import type { IssueType } from '../../common/types';
import { useProjectKey, useProject } from '../get-project';

type UseIssueTypesOption = {
	excludeEpic: boolean;
};

export const useIssueTypes = (
	{ excludeEpic }: UseIssueTypesOption = {
		excludeEpic: false,
	},
): ServiceQueryResult<IssueType[]> => {
	const baseUrl = '';
	const projectKey = useProjectKey();
	const [epicIssueTypeIds, setEpicIssueTypeIds] = useState<unknown>(null);
	const [epicIssueTypeIdsError, setEpicIssueTypeIdsError] = useState<unknown>(null);
	const projectResult = useProject();
	useEffect(() => {
		const fetchEpicIssueTypeIds = async () => {
			try {
				const epicIssueTypeIdsResult = await fetchJson<IssueTypeId[]>(
					`${baseUrl}/rest/deployments-internal/0.1/deployments/epicIssueTypeIds/${projectKey}`,
				);

				setEpicIssueTypeIds(epicIssueTypeIdsResult);
				setEpicIssueTypeIdsError(null);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				setEpicIssueTypeIdsError(error);
				setEpicIssueTypeIds(null);
			}
		};

		fetchEpicIssueTypeIds();
	}, [baseUrl, projectKey]);

	if (projectResult.error) {
		return {
			error: projectResult.error,
			loading: false,
		};
	}
	if (epicIssueTypeIdsError) {
		return {
			// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Error | undefined'.
			error: epicIssueTypeIdsError,
			loading: false,
		};
	}

	if (projectResult.loading || projectResult.data == null || epicIssueTypeIds === null) {
		return {
			loading: true,
		};
	}

	const { issueTypes } = projectResult.data;

	return {
		loading: false,
		data: issueTypes.filter(
			// @ts-expect-error - TS2571 - Object is of type 'unknown'.
			(issueType) => !excludeEpic || !epicIssueTypeIds.includes(issueType.id),
		),
	};
};
